import Seo from "@/components/seo/Seo";
import JsonLd from "@/components/seo/JsonLd";
import { softwareApplicationLd, faqPageLd } from "@/data/schema";
import { FAQ } from "@/data/site";
import Hero from "@/components/home/Hero";
import Features from "@/components/home/Features";
import AIStack from "@/components/home/AIStack";
import ComingSoon from "@/components/home/ComingSoon";
import HowItWorks from "@/components/home/HowItWorks";
import Pricing from "@/components/home/Pricing";
import DownloadHub from "@/components/home/DownloadHub";
import Faq from "@/components/home/FAQ";

export default function Home() {
    return (
        <>
            <Seo path="/" />
            <JsonLd data={softwareApplicationLd} />
            <JsonLd data={faqPageLd(FAQ)} />
            <Hero />
            <Features />
            <AIStack />
            <ComingSoon />
            <HowItWorks />
            <Pricing />
            <DownloadHub />
            <Faq />
        </>
    );
}
